/* eslint-disable */
/*
 * Controls such as the lexicon selection dropdown, create lexicon
 * button, etc.
 */

import React, { Component } from 'react'

import CRUDDropdown from './CRUDDropdown'
import '../../stylesheets/lexicon.css'

/*
 * Props:
 *
 * lexicons - The lexicons. See modules/lexicon for shape.
 * currentLexicon - The lexicon_uuid of the lexicon you're currently viewing.
 *
 * The following are all functions called on the named actions. The 
 *
 * Name                   Arguments
 * ---------------------------------------------------------------------
 * onSelectLexicon	  The selected lexicon_uuid
 * onDeleteLexicon	  The lexicon_uuid of the lexicon to be deleted
 * onRenameLexicon	  The lexicon_uuid of the lexicon to be renamed and the new name.
 * onAddLexicon		  The name of the new lexicon.
 * onToggleShowAdvanced   No arguments
 * onAddLexicalEntry      No arguments
 */

class LexiconControls extends Component {
  render () {
    return (
      <div>
	<div>
	  <label htmlFor="selectLexiconDropdown">Lexicon: &nbsp;</label>
	  <CRUDDropdown id="selectLexiconDropdown"
			items= {
			  Object.keys(this.props.lexicons).map((lexicon_uuid) => {
			    return {lexicon_uuid: lexicon_uuid, name: this.props.lexicons[lexicon_uuid].name}
			  })
			}
	                trigger={this.props.currentLexicon?this.props.lexicons[this.props.currentLexicon].name:undefined}
	                label="Lexicon"
	                onCreate={this.props.onAddLexicon}
	    	        onRead={(obj) => {this.props.onSelectLexicon(obj.lexicon_uuid)}}
	    	        onUpdate={(obj, newname) => { this.props.onRenameLexicon(obj.lexicon_uuid, newname)}}
	    	        onDelete={(obj) => {this.props.onDeleteLexicon(obj.lexicon_uuid)}}
	  />	    
	</div>

	<div>
    <label htmlFor="language">Language/Dialect: &nbsp;</label>
    <select id="language" onChange={(event) => { this.props.onSelectLanguage(event.target.value); }} value={this.props.language}>
      <option value='en-US'>American English</option>
      <option value='es-US'>US Spanish</option>
      <option value='es-MX'>Mexican Spanish</option>
      <option value='spanglish'>Spanglish</option>
    </select>
	</div>

	<div>
	  <label htmlFor="showAdvanced">Show Advanced Fields: &nbsp;</label>
	  <input id="showAdvanced" type="checkbox" onChange={this.props.onToggleShowAdvanced}/>
	</div>

	<div>
	  <button disabled={!this.props.currentLexicon}
		  onClick={this.props.onAddLexicalEntry}>
	    Add Lexical Entry
	  </button>
	</div>

      </div>
    )
  }
}

export default LexiconControls
